import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { AppState } from 'redux/root-reducer';

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
